import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import Details from '../components/Details'

@inject('rating')
@observer
class DetailsContainer extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    rating: PropTypes.object.isRequired,
    router: PropTypes.shape({
      goBack: PropTypes.func.isRequired,
    }).isRequired,
  }

  componentWillMount() {
    const { params: { id }, rating } = this.props
    rating.openById(id * 1)
  }

  @autobind
  handleClose() {
    this.props.router.goBack()
  }

  render() {
    const {
      rating,
      rating: { current },
      params: { id }
    } = this.props

    if (rating.loading) {
      return <div>Museum wird geladen</div>
    }

    if (!current || current.id !== id * 1) {
      return <div>Museum nicht gefunden!</div>
    }

    return (
      <Details
        current={current}
      />
    )
  }
}

const DetailsContainerWithRouter = withRouter(DetailsContainer)

export { DetailsContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/rating/containers/DetailsContainer.js